"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./Iframe.scss");
var _Paragraph = _interopRequireDefault(require("./Paragraph"));
var _Flex = _interopRequireDefault(require("./Flex"));
var _figmaLogo = _interopRequireDefault(require("./assets/figmaLogo.svg"));
var _excluded = ["url", "title", "style"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var IframeComponent = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var url = _ref.url,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? "Iframe Title" : _ref$title,
    style = _ref.style,
    props = _objectWithoutProperties(_ref, _excluded);
  if (!url) {
    return /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
      direction: "column",
      customClass: "FigmaIntegrationMessage"
    }, /*#__PURE__*/_react["default"].createElement(_Paragraph["default"], {
      size: "large",
      weight: "bold"
    }, "Figma integration"), /*#__PURE__*/_react["default"].createElement("img", {
      src: _figmaLogo["default"],
      className: "UpdatesLogo",
      alt: "Figma Logo"
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("iframe", _extends({
    ref: ref,
    src: url,
    title: title,
    className: "iframeComponent",
    frameBorder: "0",
    allowFullScreen: true,
    style: style
  }, props));
});
IframeComponent.propTypes = {
  url: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  style: _propTypes["default"].object
};
IframeComponent.defaultProps = {
  title: "Iframe Title",
  style: {}
};
var _default = exports["default"] = IframeComponent;